



// 



import { Pipe, PipeTransform } from '@angular/core';



@Pipe({ name: 'systemLog' })
export class SystemLogPipe implements PipeTransform {

    transform(value: string, field: string):string {

        if (!value)
            return value;

        if (field == 'request') {
            console.log(field)
            return value.substring(value.indexOf('request: '), value.indexOf('}'))
        }
        if (field == 'response') {
            console.log(field)
            return value.substring(value.indexOf('response: '), value.indexOf('}'))
        }
        return '';
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/pipes/system-log.pipe.ts